import React, { useState } from 'react';
import AppLayout from './components/layout/AppLayout';
import PageRouter from './components/PageRouter';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import useNav from './hooks/useNav';
import useAuth from './hooks/useAuth';
import { SeasonProvider } from './context/SeasonContext';
import './styles/global.css';
import './components/layout/AppLayout.css';
import './pages/pages.css';

export default function App() {
  // 'login' | 'register' | 'app'
  const [authView, setAuthView] = useState(() => {
    return sessionStorage.getItem('maaze_user') ? 'app' : 'login';
  });

  const { user, authError, authLoading, login, register, logout, setAuthError } = useAuth();

  const defaultPage = user?.role === "Organiser" ? "organiserDashboard" : "dashboard";

  const {
    active, collapsed, mobileOpen,
    toggleSidebar, navigate,
    activeItem, activeSection,
    navConfig,
  } = useNav(defaultPage, user?.role);

  // ── Handlers ──────────────────────────────────────────────
  const handleLogin = async (credentials) => {
    const ok = await login(credentials);
    if (ok) setAuthView('app');
  };

  const handleRegister = async (formData) => {
    const ok = await register(formData);
    if (ok) setAuthView('app');
  };

  const handleLogout = () => {
    logout();
    setAuthView('login');
  };

  const goToRegister = () => { setAuthError(''); setAuthView('register'); };
  const goToLogin = () => { setAuthError(''); setAuthView('login'); };

  // ── Render ─────────────────────────────────────────────────
  // If session exists, jump straight to app
  if (user && authView !== 'login' && authView !== 'register') {
    return (
      <SeasonProvider>
        <AppLayout
          active={active}
          collapsed={collapsed}
          mobileOpen={mobileOpen}
          onNavigate={navigate}
          onToggle={toggleSidebar}
          activeSection={activeSection}
          activePage={activeItem?.label}
          user={user}
          onLogout={handleLogout}
          navConfig={navConfig}
        >
          {/* <PageRouter active={active} /> */}
          <PageRouter active={active} role={user?.role} />
        </AppLayout>
      </SeasonProvider>
    );
  }

  if (authView === 'register') {
    return (
      <RegisterPage
        onRegister={handleRegister}
        onGoLogin={goToLogin}
        error={authError}
        loading={authLoading}
      />
    );
  }

  return (
    <LoginPage
      onLogin={handleLogin}
      onGoRegister={goToRegister}
      error={authError}
      loading={authLoading}
    />
  );
}
